import React from 'react';
import AntIcon from '@ant-design/icons';
import * as ReactIcons from '../icons';
import * as LocalIcons from '../../icons';
import styles from '../index.module.scss';
import cx from 'clsx';

export const RenderIcon = ({ icon, iconSize, color, className, ...rest }) => {
  const Component = ReactIcons[icon] || LocalIcons[icon];

  return (
    <AntIcon
      className={cx(styles.icon, className)}
      color={color}
      style={{
        '--icon-size': iconSize,
        '--icon-color': color,
        '--icon-stroke': 'currentColor',
        ...rest.iconStyles,
      }}
      {...(!!Component ? { component: () => <Component size={iconSize} {...rest} /> } : {})}
    />
  );
};
